import React, { Component } from "react";
import Scanner from "./Scanner";
import Slideshow from "./Slideshow";
import Button from "react-bootstrap/Button";
import { NavLink } from "react-router-dom";
import { AiFillCamera } from "react-icons/ai";

export default class Barcode extends Component {
  constructor(props) {
    super(props);
    this._onDetected = this._onDetected.bind(this);
    this.handleFileSelect = this.handleFileSelect.bind(this);
  }
  state = {
    errorMessage: "",
    scanning: false,
  };
  handleFileSelect = (evt) => {
    if (evt.target.files && evt.target.files.length > 0) {
      let imgSize = evt.target.files[0].size;
      if (imgSize <= 204857600) {
        this.props.addComplaintFile(evt.target.files[0]);
      } else {
        const errorMessage = "حجم فایل نباید بیشتر از 20 مگابایت باشد.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      }
    }
  };
  _scan = () => {
    this.setState({ scanning: !this.state.scanning });
  };
  _onDetected = (result) => {
    if (result !== null) {
      var element = document.getElementById("SN_Number");
      element.value = result.codeResult.code;
    }
  };
  handleSaveSN = () => {
    var e = document.getElementById("SN_Number");
    let currentValue = e.value;
    currentValue = currentValue.replace(/\s/g, "");
    if (currentValue.length >= 9 && currentValue.length <= 21) {
      this.props.saveSerialForUser(currentValue);
    } else {
      const erm =
        currentValue.length === 0
          ? "بارکد محصول خود را وارد نمایید."
          : "بارکد محصول وارد شده اشتباه است.";
      this.setState({ errorMessage: erm });
    }
  };
  render() {
    return (
      <React.Fragment>
        <div className="item barcode-scanner">
          {/*<div className="d-flex justify-content-center">
            <span className="btn btn-lg dina-bc-orange text-white px-4 mt-2">
              ثبت دستی بارکد
            </span>
          </div>*/}
          <div className="mt-2">
            <input
              id="SN_Number"
              name="SN_Number"
              type="text"
              className="form-control form-control-lg text-center barcodeWritten rounded-0"
              placeholder="برای ثبت دستی بارکد محصول، آن را در اینجا وارد نمایید."
              minLength={9}
              maxLength={21}
              onKeyUp={this.handleSN}
            ></input>
            <Button
              className="btn btn-success rounded-0 nowrap my-2 px-5"
              onClick={this.handleSaveSN}
              id="sing-in-button"
            >
              ثبت بارکد
            </Button>
          </div>
          <p className="wp-text-small text-danger mb-0">
            {this.state.errorMessage}
          </p>
          <div className="d-flex">
            <button
              className={
                this.state.scanning
                  ? "btn btn-danger mt-2 rounded-0 col-6 p-0 m-0"
                  : "btn btn-primary mt-2 rounded-0 col-6 p-0 m-0"
              }
              onClick={this._scan}
              id="barcode-reader"
            >
              {this.state.scanning
                ? "غیرفعال کردن بارکدخوان"
                : "فعال کردن بارکدخوان"}
            </button>
            <div className="file-input mt-2 btn btn-info rounded-0 col-6">
              <input
                type="file"
                id="inputId"
                className="file"
                accept="image/*"
                onChange={this.handleFileSelect}
              ></input>
              <label htmlFor="inputId" className="text-white">
                <AiFillCamera /> ارسال تصویر بارکد
              </label>
            </div>
          </div>
        </div>
        <div className="item barcode-submiter">
          <button className="btn dina-btn-blue px-4 mt-2 relative">
            <NavLink to="/chat" className="text-decoration-none text-white">
              تالار گفتگوی عمومی
            </NavLink>
            <span className="badge unseen bg-danger">{this.props.unSeen}</span>
          </button>
        </div>
        {this.state.scanning ? (
          <div id="dina-reader" className="item">
            <div className="barcode-div">
              <Scanner onDetected={this._onDetected} />
            </div>
          </div>
        ) : null}
        <div
          className={this.state.scanning ? "SlideWithScan" : "SlideWithOutScan"}
        >
          <Slideshow moduleJson={this.props.moduleJson}></Slideshow>
        </div>
      </React.Fragment>
    );
  }
  handleSN = (e) => {
    const currentValue = e.target.value;
    //this.setState({serialnumber: currentValue});
    if (currentValue.length >= 9 && currentValue.length <= 21) {
      this.setState({ errorMessage: "" });
    } else {
      const erm =
        currentValue.length === 0
          ? "بارکد محصول خود را وارد نمایید."
          : "بارکد محصول وارد شده اشتباه است.";
      this.setState({ errorMessage: erm });
    }
  };
}
